import type { ApiLinkModel } from '~/types/contentapi';
export const useLinkParser = () => {
  const parseQuery = (queryString: string | null): Record<string, string> | undefined => {
    if (!queryString) return undefined;
    return queryString.split('&').reduce(
      (acc, pair) => {
        const [key, value] = pair.split('=');
        if (key) {
          acc[key] = value || '';
        }
        return acc;
      },
      {} as Record<string, string>
    );
  };

  const getNiceLink = (linkData: ApiLinkModel) => {
    if (!linkData)
      return {
        title: null,
        href: null,
        target: null
      };

    const pathOrUrl = linkData.route?.path || linkData.url || '#';
    const query = parseQuery(linkData.queryString);
    const to = query !== undefined ? { path: pathOrUrl, query } : pathOrUrl;

    return {
      title: linkData.title,
      href: to,
      target: linkData.target
    };
  };

  return {
    getNiceLink
  };
};
